import { pick } from 'lodash';
import { binToStr } from '@zapier/product-get-help/src/utils';

type ErrorBundle = {
  id: string;
  title: string;
  code?: string;
  status?: number;
  step: string;
};

const decodeErrorBundle = (base64Bundle: string): ErrorBundle | undefined => {
  try {
    const binaryBundle = atob(base64Bundle);
    const jsonBundle = binToStr(binaryBundle);
    const errorBundle: ErrorBundle = JSON.parse(jsonBundle);
    const slimBundle = pick(
      errorBundle,
      'id',
      'title',
      'code',
      'status',
      'step'
    );
    return slimBundle;
  } catch (_) {
    return undefined;
  }
};

export default decodeErrorBundle;
